import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import PhaseType from 'types/phase';

export const laborsheet_approved = ({ event: { kind, data: { name, date } } }) =>
  <div className={kind}>
    {name} has approved the labor sheet dated {moment(date).local().format('MM/DD/YYYY')}.
  </div>;

laborsheet_approved.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      name: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/laborsheet_approved.jsx